import { WEB_ICO } from '../shell/icons';

/** Stub cho các màn chưa dựng trong đợt này — khớp PlaceholderScreen bên mobile. */
export function PlaceholderPage({ title }: { title: string }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, padding: '80px 24px', textAlign: 'center', fontFamily: 'var(--font-vi)' }}>
      {WEB_ICO.ai('var(--icon-secondary)', 40)}
      <h2 style={{ fontSize: 19, fontWeight: 700, color: 'var(--ink)', margin: 0 }}>{title}</h2>
      <p style={{ fontSize: 14, color: 'var(--text-secondary)', margin: 0 }}>Màn hình này đang ở đợt phát triển tiếp theo.</p>
    </div>
  );
}
